function badgerQL() {
  const IDENT_RE = "[A-Za-z_-][0-9A-Za-z_-]*";
  const BADGERQL_FNS = [
    "stats",
    "filter",
    "sort",
    "limit",
    "fields",
    "unique",
    "limit",
    "only",
    "parse",
    "expand",
    "fill",
  ];

  const infixOps = [
    ">",
    "<",
    "==",
    "!=",
    "<>",
    "<=",
    ">=",
    "between",
    "not between",
    "in",
    "not in",
    "like",
    "not like",
    "ilike",
    "not ilike",
    "match",
    "not match",
    "and",
    "or",
    "+",
    "-",
    "/",
    "%",
    "*",
  ];
  const infix = `\\b(${infixOps.join("|").replace(/[=><\-[\]/{}()*+?.\\^$!]/g, "\\$&")})\\b`;

  const decimalDigits = "[0-9](_?[0-9])*";
  const frac = `\\.(${decimalDigits})`;
  const decimalInteger = `0|[1-9](_?[0-9])*|0[0-7]*[89][0-9]*`;
  const NUMBER = {
    className: "number",
    variants: [
      {
        begin:
          `(\\b(${decimalInteger})((${frac})|\\.)?|(${frac}))` +
          `[eE][+-]?(${decimalDigits})\\b`,
      },
      { begin: `\\b(${decimalInteger})\\b((${frac})\\b|\\.)?|(${frac})\\b` },
      { begin: `\\b(0|[1-9](_?[0-9])*)n\\b` },
      { begin: "\\b0[xX][0-9a-fA-F](_?[0-9a-fA-F])*n?\\b" },
      { begin: "\\b0[bB][0-1](_?[0-1])*n?\\b" },
      { begin: "\\b0[oO][0-7](_?[0-7])*n?\\b" },
      { begin: "\\b0[0-7]+n?\\b" },
    ],
    relevance: 0,
  };

  const FUNCTION_DEFINITION = {
    variants: [
      {
        match: [IDENT_RE, /(?=\s*\()/],
      },
    ],
    className: { 1: "title.function" },
    label: "func.def",
  };

  return (hljs) => ({
    name: "BadgerQL",
    disableAutodetect: true,
    keywords: BADGERQL_FNS,
    contains: [
      NUMBER,
      FUNCTION_DEFINITION,
      {
        className: "attr",
        begin: "`[^\\n]*`",
      },
      hljs.APOS_STRING_MODE,
      hljs.QUOTE_STRING_MODE,
      hljs.REGEXP_MODE,
      hljs.COMMENT(/(\||^)\s*!/, /(?=\|)/),
      {
        scope: "regexp",
        begin: /\(\?</,
        end: />/,
      },
      {
        scope: "built_in",
        match: infix,
      },
      {
        scope: "built_in",
        match: /\b(?:as|by)\b/,
      },
      {
        match: [IDENT_RE, /::[A-Za-z_][0-9A-Za-z_]*/],
        scope: { 2: "punctuation" },
      },
    ],
  });
}

export default badgerQL;
